import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import KpsEditor from "../editor/KpsEditor";

class AnswerNode extends Component {
  render() {
    return (
      <div>
        <Button
          variant="outlined"
          fullWidth
          onClick={() =>
            this.props.changeQuestion(
              this.props.node,
              this.props.node.children[0]
            )
          }
        >
          {this.props.node.label}
        </Button>
        <DialogContent>
          <KpsEditor initialContent={this.props.node.notes} readOnly />
        </DialogContent>
      </div>
    );
  }
}
export default AnswerNode;
